import { useState, useEffect } from "react"
import api from "../../api/axios"; 
import "./Settings.css";
import { toast } from "react-toastify";

function Notification() {
    const [preferredEmail, setPreferredEmail] = useState("");
    const [preferredEmails, setPreferredEmails] = useState(["samuel123@abc.com"]);
    
    // ✅ NEW: Permission state
    const [canWrite, setCanWrite] = useState(false);

    // ✅ NEW: Fetch permissions on mount
    useEffect(() => {
        const fetchNotificationPerms = async () => {
            try {
                const res = await api.get("/user-roles/me");
                const role = res.data;

                // ✅ FIX: If Admin, grant full write access to switches and email inputs
                if (role.isAdmin) {
                    setCanWrite(true);
                    return;
                }

                if (role && !role.noRoleDefined) {
                    // Check both columns for "Notifications"
                    const writeStr = role.write_access || "";
                    const bothStr = role.both_access || "";
                    
                    const hasWritePerm = writeStr.includes("Notifications") || bothStr.includes("Notifications");
                    setCanWrite(hasWritePerm);
                } else {
                    setCanWrite(true); // Default for users with no roles
                }
            } catch (err) {
                console.error("Notification permission check failed");
                setCanWrite(false); 
            }
        };
        fetchNotificationPerms();
    }, []);

    const [notifications, setNotifications] = useState([
        { id: 1, type: "Document & Knowledge Updates", enabled: true },
        { id: 2, type: "AI & Agent Activity", enabled: true },
    ]);

    const [emailnotifications, setemailNotifications] = useState([
        { id: 1, type: "Document & Knowledge Updates", enabled: true, frequency: "Daily" },
        { id: 2, type: "AI & Agent Activity", enabled: true, frequency: "Immediate" },
        { id: 3, type: "Reports & Summaries", enabled: true, frequency: "Weekly" }
    ]);

    const toggleNotification = (id) => {
        if (!canWrite) return; // ✅ Blocked if no write access
        setNotifications((prev) =>
            prev.map((item) => item.id === id ? { ...item, enabled: !item.enabled } : item)
        );
    };

    const emailtoggleNotification = (id) => {
        if (!canWrite) return; // ✅ Blocked if no write access
        setemailNotifications((prev) =>
            prev.map((item) => item.id === id ? { ...item, enabled: !item.enabled } : item)
        );
    };

    const changeFrequency = (id, value) => {
        if (!canWrite) return; // ✅ Blocked if no write access
        setemailNotifications((prev) =>
            prev.map((item) => item.id === id ? { ...item, frequency: value } : item)
        );
    };

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const addPreferredEmail = () => {
        const email = preferredEmail.trim();
        if (!email || !canWrite) return;
        if (!isValidEmail(email)) { toast.warning("Please enter a valid email address"); return; }
        if (preferredEmails.includes(email)) { toast.warning("Email already added"); return; }
        setPreferredEmails((prev) => [...prev, email]);
        setPreferredEmail("");
    };

    const removePreferredEmail = (email) => {
        if (!canWrite) return; // ✅ Blocked if no write access
        setPreferredEmails((prev) => prev.filter((item) => item !== email));
    };

    return (
        <>
            <div className="conatainer-notification bg-white p-4 rounded-4 shadow-sm text-start">
                <div className="content">
                    <div className="mb-3"><h5 className="fw-semibold mb-0 settings-section-heading">In App-Notifications</h5></div>
                </div>
                <div className="table-responsives">
                    <table className="table align-middle mb-0">
                        <thead className="head-color fs-6 p-3"> <tr>
                        <th className="head-color " style={{ width: "43%" }}>
                            Type
                            <img src="/images/userRoleDrop.svg" className="ms-2" alt="" />
                        </th>
                        <th className="text-center head-color">Enable / Disable</th>
                    </tr></thead>
                        <tbody>
                            {notifications.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.type}</td>
                                    <td className="text-center">
                                        <div className="form-check form-switch d-inline-block">
                                            <input
                                                className="form-check-input notification-switch"
                                                type="checkbox"
                                                checked={item.enabled}
                                                disabled={!canWrite} // ✅ Unblocked for Admin
                                                onChange={() => toggleNotification(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="mt-3">
                        <h6 className="fw-semibold mb-3">Email Notifications</h6>
                        <div className="table-responsives">
                            <table className="table align-middle mb-0">
                                <thead className="head-color">
                                    <tr>
                                        <th>Type <img src="/images/userRoleDrop.svg" className="ms-2" alt="" /></th>
                                        <th className="text-end">Enable / Disable</th>
                                        <th className="text-center">Frequency</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emailnotifications.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.type}</td>
                                            <td className="text-end">
                                                <div className="form-check form-switch d-inline-block">
                                                    <input
                                                        className="form-check-input notification-switch"
                                                        type="checkbox"
                                                        checked={item.enabled}
                                                        disabled={!canWrite} // ✅ Unblocked for Admin
                                                        onChange={() => emailtoggleNotification(item.id)}
                                                    />
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <select
                                                    className="form-select form-select-sm  mx-auto"
                                                    value={item.frequency}
                                                    onChange={(e) => changeFrequency(item.id, e.target.value)}
                                                    disabled={!item.enabled || !canWrite} // ✅ Unblocked for Admin
                                                >
                                                    <option value="Immediate">Immediate</option>
                                                    <option value="Daily">Daily</option>
                                                    <option value="Weekly">Weekly</option>
                                                </select>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* ✅ Section visible and usable for Admin */}
                {canWrite && (
                    <div className="mt-4">
                        <h6 className="fw-semibold mb-3">Preferred Email</h6>
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <input
                                type="email"
                                className="form-control w-50 inputsfeild"
                                placeholder="michael@abccompany.com"
                                value={preferredEmail}
                                onChange={(e) => setPreferredEmail(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-addns"
                                onClick={addPreferredEmail}
                                disabled={!preferredEmail.trim()}
                            >
                                Add
                            </button>
                        </div>

                        <div className="d-flex flex-wrap gap-2">
                            {preferredEmails.map((email) => (
                               <span
                                key={email}
                                className="badge rounded-pill bg-primary-subtles d-flex align-items-center gap-2 px-3 py-2"
                              >
                                    {email}
                                    <button
                                        type="button"
                                        className="btn-close btn-close-sm"
                                        onClick={() => removePreferredEmail(email)}
                                    />
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
export default Notification;